import { Formik } from "formik";
import ErrorBoundary from "../ErrorBoundary";
import ForgotPasswordFields from "../../formsFields/ForgotPasswordFields";
import { Link, useHistory } from "react-router-dom";
import LogoSVG from "../../../assets/svg/Logo";
import Button from "../../organism/Button";
import validations from "../../../services/validations";
import ForgetPasswordFormValues from "../../../services/models/formModels/forgetpasswordformvalues.interface";
import toastMessages from "../../../services/utils/helpers/toastMessage";
import OktaAuth from "@okta/okta-auth-js";
import { useState } from "react";
import OktaConfig from "../../../config/oktaConfig";
const oktaAuth = new OktaAuth(OktaConfig.oktaAuthConfig);

function ForgotPasswordForm(): JSX.Element {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const history = useHistory();
  const initialValues: ForgetPasswordFormValues = { email: "" };

  function onSubmit(data: ForgetPasswordFormValues): void {
    setSubmitting(true);
    oktaAuth
      .forgotPassword({
        username: data.email,
        factorType: "EMAIL",
      })
      .then(function (transaction: any) {
        if (transaction.status === "RECOVERY_CHALLENGE") {
          toastMessages.success(
            "A link was sent to your email. Please click on that link to reset your password.",
            3000
          );
          history.push("/");
        } else {
          toastMessages.error(
            "Something went wrong, please contact your Administrator.",
            3000
          );
        }
        setSubmitting(false);
      })
      .catch(function (err) {
        toastMessages.error(
          err?.message ? err.message : "Error changing password",
          3000
        );
        setSubmitting(false);
      });
  }
  return (
    <ErrorBoundary>
      <Formik
        initialValues={initialValues}
        isInitialValid={false}
        validationSchema={validations.forgotPasswordValidation}
        onSubmit={onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          isValid,
          handleSubmit,
          submitForm,
          isSubmitting,
          getFieldMeta,
        }) => (
          <form
            onSubmit={handleSubmit}
            className="px-[126px] flex flex-col justify-center h-full"
          >
            <div className="my-4">
              <Link to={"/"}>
                <LogoSVG width={112} height={38} className="my-4" />
              </Link>
              <div className="flex items-center">
                <h3 className="text-title my-1.5">Change Password</h3>
              </div>
              <h5 className="text-subTitle">
                Please enter your account email id
              </h5>
            </div>
            <ForgotPasswordFields
              values={values}
              touched={touched}
              errors={errors}
              getFieldMeta={getFieldMeta}
              showPhysicianFields={false}
              handleChange={handleChange}
              handleBlur={handleBlur}
            />
            <Button
              textInformation={{
                text: "Verify",
                fontWeight: "font-semibold",
              }}
              buttonTheme="primary"
              onClick={() => submitForm()}
              disabled={!isValid || submitting}
              loading={submitting}
            />
          </form>
        )}
      </Formik>
    </ErrorBoundary>
  );
}

export default ForgotPasswordForm;
